import { useQuery } from '@tanstack/react-query';

import { getPatients, type ListPatientsParams } from '../../../api/patients';
import { useAuth } from '../../auth/AuthProvider';

export function usePatients(params: ListPatientsParams = {}) {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['patients', params],
    queryFn: () => getPatients(params, tokens!.access_token),
    enabled: Boolean(tokens?.access_token),
  });
}
